// New design system component: underline-style tabs wrapper.
// Pairs with components/CustomTabPanel for the panels.

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

export function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function UnderlineTabs({ value, onChange, tabs, ...rest }) {
  return (
    <Tabs value={value} onChange={onChange} {...rest}>
      {tabs.map((tab, index) => (
        <Tab
          key={tab.value !== undefined ? tab.value : index}
          label={tab.label}
          value={tab.value !== undefined ? tab.value : index}
          disabled={tab.disabled}
          icon={tab.icon}
          iconPosition={tab.icon ? "start" : undefined}
          {...a11yProps(index)}
        />
      ))}
    </Tabs>
  );
}

UnderlineTabs.defaultProps = {
  onChange: () => {},
};

UnderlineTabs.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      disabled: PropTypes.bool,
      icon: PropTypes.node,
    })
  ).isRequired,
};

export default UnderlineTabs;
